import React, { useState, useEffect } from 'react';
import './Slidebar.scss';
import Slider from '@material-ui/core/Slider'
import { connect } from 'react-redux'

const Slidebar = (props) => {
    const { valuesMinMax, onClick } = props
    const [value, setValue] = useState(valuesMinMax)

    // useEffect(() => {
    //     setValue(props.valuesMinMax);
    // }, [props.productsCategory])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeCommitted = (event, newValue) => {
        onClick(newValue)
    };

    return (
        <div className="slidebar-container">
            <Slider
                value={value}
                onChangeCommitted={handleChangeCommitted}
                onChange={handleChange}
                min={props.valuesMinMax[0]}
                max={props.valuesMinMax[1]}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
            />
            <div>De {valuesMinMax[0]}cm a {valuesMinMax[1]}cm</div>
        </div>
    );
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(Slidebar)